export default "__VITE_ASSET__BwTb6mpH__"